/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  font-size: 1rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  contain: content;
  outline: 0;
  font-size: calc(12rem/14);
}
:host > .container {
  cursor: pointer;
}
:host > .container > davinci-button {
  font-size: inherit;
  box-sizing: border-box;
  margin-bottom: 0;
  padding: 0;
  width: 100%;
  display: block;
}
:host > .container > input[type=file] {
  display: none;
}
:host > .container > input[type=file]:disabled {
  cursor: default;
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
}`;
export { style };
//# sourceMappingURL=FileChooser.style.js.map